<template>
    <div class="corporate_content">
        <div class="corporate_swiper" v-if="corporateList.length > 0">
            <swiper :options="corporateSwiperOptionOne" @slideChange='slideChange' class="corporate_swiper_img swiper-no-swiping" ref="swiperTop">
                <swiper-slide v-for="(item,index) in corporateList" :key="index">
                    <img :src="item.url"/>
                </swiper-slide>
            </swiper>
            <div class="gallery_thumbs">
                <div class="corporate_title">{{title}}</div>
                <swiper :options="corporateSwiperOption" ref='swiperThumbs' class="pagination_img swiper-no-swiping">
                    <swiper-slide v-for="(item,index) in corporateList" @click.native="clickSwiper(index)" :key="index" :class="item.style">
                        <img :src="item.url"/>
                    </swiper-slide>
                </swiper>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';

export default {
    name: 'companyBlock',
    components: {
        Layout,
    },
    props: {
        company: {},
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            companyStyle: this.$props.company,
            corporateList: [],
            corporateSwiperOptionOne: {
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                loop: true,
                slideToClickedSlide: true,
            },
            corporateSwiperOption: {
                slidesPerView: 5,
                spaceBetween: 16,
                slidesPerGroup: 5,
                loop: true,
                loopFillGroupWithBlank: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                touchRatio: 0.2,
                loopedSlides: 5,
                slideToClickedSlide: true,
            },
        };
    },
    created() {
        ajax.get('/web/homepage/company_style_list.json', { }).then((result) => {
            const newCorporateList = [];
            for (let i = 1; i <= 5; i += 1) {
                result.dataList.forEach((item) => {
                    newCorporateList.push({
                        style: '',
                        url: item.image,
                        cnImageName: item.cnImageName,
                        enImageName: item.enImageName,
                    });
                });
            }
            newCorporateList[0].style = 'slide_active';
            this.corporateList = newCorporateList;
            this.title = this.isCn ? this.corporateList[0].cnImageName : this.corporateList[0].enImageName;
        }).catch(() => {});
    },
    watch: {
        $route() {
            this.$forceUpdate();
            this.clickSwiper(0);
            setTimeout(() => {
                this.clickSwiper(1);
            }, 3000);
        },
        company() {
            this.companyStyle = this.$props.company;
        },
    },
    methods: {
        slideChange() {
            const swiperTop = this.$refs.swiperTop.swiper;
            const swiperThumbs = this.$refs.swiperThumbs.swiper;
            const count = swiperTop.realIndex;
            this.title = this.isCn ? this.corporateList[count].cnImageName : this.corporateList[count].enImageName;
            this.corporateList.map((item, index) => {
                if (index === count) {
                    item.style = 'slide_active';
                } else {
                    item.style = 'slide_default';
                }
                return item;
            });
            swiperThumbs.slideToLoop(count, 1000, false);
        },
        clickSwiper(index) {
            const swiperTop = this.$refs.swiperTop.swiper;
            swiperTop.slideToLoop(index, 1000, false);
            this.title = this.isCn ? this.corporateList[index].cnImageName : this.corporateList[index].enImageName;
        },
    },
};
</script>
<style lang="less" scoped>
.corporate{
    width: 100%;
    display: flex;
    justify-content: center;
}
.corporate_content {
    width: 1200px;
    margin-left: -120px;
    padding: 60px 0 30px;
    .title {
        width: 100%;
        margin-bottom: 20px;
        p {
            width: 100%;
            text-align: center;
            font-size:20px;
        }
        .cn {
            font-weight:600;
            color:rgba(74,74,74,1);
            &:first-letter {
                // vertical-align: bottom;
                font-size: 36px;
            }
        }
        .en {
            font-weight:600;
            color:rgba(199,31,75,1);
            letter-spacing: -1.2px;
        }
    }
}
.corporate_swiper{
    width: 1200px;
    height: 464px;
    position: relative;
    .corporate_swiper_img{
        width: 1200px;
        height: 464px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .gallery_thumbs{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 1200px;
        height: 150px;
        display: flex;
        align-items: center;
        background:rgba(0,0,0,0.45);
        z-index: 80;
        .slide_active{
            opacity: 1;
            img{
                border: 1px solid #C71F4B;
                box-sizing: border-box;
            }
            &:after{
                content: "";
                width: 0px;
                height: 0px;
                border-left: 6px solid transparent;
                border-right: 6px solid transparent;
                border-bottom: 6px solid #C71F4B;
                position: absolute;
                top: 17px;
                left: 50px;
            }
        }
        .corporate_title{
            width: 410px;
            font-size:12px;
            font-weight:500;
            word-break: break-word;
            color:rgba(255,255,255,1);
            max-height: 64px;
            line-height: 21px;
            padding: 0 50px;
            margin: 40px 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
        }
        .pagination_img{
            width: 664px;
            height: 86px;
            margin-left: 42px;
            img{
                width: 100%;
                max-width: 120px;
                height: 46px;
                margin-top: 23px;
            }
            .slide_default{
                opacity: 0.6;
            }
        }
        .swiper-button-prev{
            width:22px;
            height:22px;
            margin-top: -10px;
            outline: none;
            background-image: url('../../style/index_swiper_button_prev.png');
            background-size: 100% 100%;
            left: 420px;
        }
        .swiper-button-next{
            width:22px;
            height:22px;
            margin-top: -10px;
            outline: none;
            background-image: url('../../style/index_swiper_button_next.png');
            background-size: 100% 100%;
            right: 50px;
        }
    }
}
</style>
